import { FC } from "react";
import { useTranslation } from "react-i18next";
import { getFacebookFollowersDefinitionInfo } from "../OrganicMediaDefinitions";
import FacebookRankedFollowersPanel, {
  type FacebookFollowersGeoRow,
} from "./FacebookRankedFollowersPanel";
import "../../../styles/FacebookFollowersReport/FacebookFollowersByCity.scss";

type FacebookFollowersByCityProps = {
  rows: FacebookFollowersGeoRow[];
  value: number;
  max: number;
  onChange: (_value: number) => void;
};

const FacebookFollowersByCity: FC<FacebookFollowersByCityProps> = ({
  rows,
  value,
  max,
  onChange,
}) => {
  const { t } = useTranslation();

  return (
    <FacebookRankedFollowersPanel
      title={t("organicMedia.followers.totalByCity")}
      tooltipInfo={getFacebookFollowersDefinitionInfo("Total Followers by City", undefined, t)}
      topLabel={t("organicMedia.followers.topCitiesLabel")}
      rows={rows}
      value={value}
      disabled={rows.length === 0}
      onChange={next => {
        const n = Math.max(1, Math.min(max, next));
        onChange(n);
      }}
      formulaTitle={t("organicMedia.common.formula")}
      emptyLabel={t("webAnalytics.noData")}
    />
  );
};

export default FacebookFollowersByCity;
